module.exports = __webpack_public_path__ + "static/media/air2.591d1efc.mp4";